import { render, staticRenderFns } from "./TabContactsHeader.vue?vue&type=template&id=7801ddcb&"
import script from "./TabContactsHeader.vue?vue&type=script&lang=js&"
export * from "./TabContactsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TabContactsHeader.vue?vue&type=style&index=0&id=7801ddcb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports